module.exports = __webpack_public_path__ + "img/jt02.2d290283.png";